import React from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'

const SEO = ({ title, description='', keywords='', ogTitle, ogSiteName, jsonLd }) => {
    return (
        <HelmetProvider>
            <Helmet>
                {title && <title>{title}</title>}
                {description && <meta name="description" content={description} />}
                {keywords && <meta name="keywords" content={keywords} />}
                {ogTitle && <meta property="og:title" content={ogTitle} />}
                {ogSiteName && <meta property="og:site_name" content={ogSiteName} />}
                {jsonLd && <script type="application/ld+json">{` { "@context": "http://schema.org", "@type": "Product", "name": "${jsonLd.name}", "image": "${jsonLd.image}", "description": "${jsonLd.description}", "brand": { "@type": "Brand", "name": "${jsonLd.brand}" }, "sku": "${jsonLd.sku}", "mpn": "${jsonLd.mpn}", "productID": "${jsonLd.productID}", "offers": { "@type": "Offer", "price": "${jsonLd.price}", "priceValidUntil": "${jsonLd.priceValidUntil}", "priceCurrency": "KRW", "availability": "http://schema.org/InStock", "url": "${jsonLd.url}" } ${jsonLd.ratingCount > 0 ? (` , "aggregateRating": { "@type": "AggregateRating", "ratingValue": "${jsonLd.ratingValue}", "bestRating": "5", "worstRating": "1", "ratingCount": "${jsonLd.ratingCount}" } `) : ''} } `}</script>}
            </Helmet>
        </HelmetProvider>
    )
}
export default SEO



// WEBPACK FOOTER //
// ./src/common/util/seo.js